import React from "react";

const Msg = ({ msg }) => {
	let pStyle = {
		marginBottom: "15px",
	};
	let bClass = "hidden";
	if (msg && msg.note) {
		pStyle.color = msg.color;
		bClass = "";
	}

	return msg && msg.text ? (
		<p style={pStyle}>
			<b className={bClass}>Note: </b>
			{msg.text}
		</p>
	) : (
		<div className="spacer" />
	);
};

export default Msg;



// WEBPACK FOOTER //
// ./src/Msg.js